export interface ShowWithDisabledConfig {
    show: boolean;
    disabled: boolean;
}

export const defaultShowWithDisabledConfig: ShowWithDisabledConfig = {
    show: true,
    disabled: false,
};

export const disabledShowWithDisabledConfig: ShowWithDisabledConfig = {
    show: true,
    disabled: true,
};

export const hiddenShowWithDisabledConfig: ShowWithDisabledConfig = {
    show: false,
    disabled: true,
};

export interface LensActionsVisibilityState {
    downloadQrCode: boolean; // TODO: Add spectacles logic + implementation
    deleteLens: boolean;
    setTags: boolean;
    setVisibility: boolean;
    setLensCta: boolean;
    setLensCategory: boolean;
    setPreview: boolean;
    manageDigitalGoods: boolean;
    finalize: boolean;
    copyDeeplink: boolean;
    publishToSnapchatConfig: ShowWithDisabledConfig;
    enrollCreatorPayout: ShowWithDisabledConfig; // TODO: Add spectacles logic + implementation
    setLensDescription: boolean;
    deleteHostedWebAr: boolean;
    generateHostedWebAr: boolean;
}
